module.exports = __webpack_public_path__ + "img/confirmed-ringer.6cb36104.svg";